export enum UserUploadStage {
    Uploaded = 0,
    Validating = 1,
    Comparing = 2,
    ReadyForImport = 3,
    Completing = 9,
    Cancelling = 41,
    Completed = 10,
    Failed = 50,
    Cancelled = 51,
    Errored = 52
}

export interface UserUploadHistory {
    addedRowCount: number
    comparisonCompletedAt: string
    comparisonFileName: string
    comparisonFileUri: string
    comparisonReportFileName: string
    comparisonReportFileUri: string
    comparisonStartedAt: string
    createDate: string
    createdBy: string
    durableFunctionInstanceId: string
    erroredRowCount: number
    fileName: string
    id: number
    importCompletedAt: string
    importSettingsStoredName: string
    importSettingsStoredUri: string
    importStartedAt: string
    logFile: string
    modifiedBy: string
    modifiedDate: string
    modifiedRowCount: number
    originalFileStoredName: string
    originalFileStoredUri: string
    parsedFileName: string
    parsedFileUri: string
    reactivatedRowCount: number
    removedRowCount: number
    requestId: string
    resultsFile: string
    status: UserUploadStage 
    unchangedCount: number
    validationCompletedAt: string
    validationErrorFileName: string
    validationErrorFileUri: string
    validationStartedAt: string
    groupImportAvailable: boolean;
    groupImportCompleted: boolean;
    groupImportCompletedAt: string;
    groupImportStartedAt: string;
    groupsAdded: number;
    totalLinesInFile:number;
    userImportType:string
}
